import { useDispatch } from "react-redux";
import { displayErrorMessage } from "@agricircle/shared/redux";
import { useAsyncApi } from "@agricircle/shared/hooks";

export const useSoilCarbonApi = () => {
    const dispatch = useDispatch();
    const sendRequest = useAsyncApi();

    ////////////////// Prepare soil carbon kit
    const prepareKit = async (farmId, fieldIds, options, callback) => {
        const result = await sendRequest("POST", `datahub/soc/kit/${farmId}`, { "field_ids": fieldIds, options });
        if (result.isError)
            dispatch(displayErrorMessage("Failed to prepare soil carbon kit", result.data));
        else if (callback)
            callback(result.data);
        return result;
    };

    ////////////////// soc kit status
    const farmKitStatus = async (farmId, callback) => {
        const url = `datahub/soc/kit/${farmId}`
        const result = await sendRequest("GET", url);
        if (result.isError) {
            if (result.status == 422) {
                callback(result.data);
                return;
            }
            dispatch(displayErrorMessage("Failed to get farm soc status", result.data));
        } else if (callback)
            callback(result.data);
        return result;
    };

    ////////////////// soil carbon kit status
    const kitStatus = async (farmId, jobId, callback) => {
        const url = `datahub/soc/kit/${farmId}/${jobId}`
        const result = await sendRequest("GET", url);
        if (result.isError) {
            if (result.status == 422) {
                callback(result.data);
                return;
            }
            dispatch(displayErrorMessage("Failed to get status", result.data));
        } else if (callback)
            callback(result.data);
        return result;
    };

    ////////////////// cancel soc kit
    const cancelKit = async (farmId, jobId, callback) => {
        const url = `datahub/soc/kit/${farmId}/${jobId}`
        const result = await sendRequest("DELETE", url);
        if (result.isError)
            dispatch(displayErrorMessage("Failed to cancel request", result.data));
        else if (callback)
            callback();
        return result;
    };

    return { prepareKit, farmKitStatus, kitStatus, cancelKit };
};
